import { Mail } from '@mui/icons-material';
import {
  Box,
  Button,
  Fab,
  Snackbar,
  SnackbarContent,
  Stack,
  Typography
} from '@mui/material';

import React, { useState } from 'react';
import * as ds from './dataService';



export type NotificationWidgetProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: NotificationWidgetProps) => {
  const [
    isOpen,
    setIsOpen
  ] = useState(false);

  const { data } = ds.useQuery();

  return (
    <Box>
      <Fab
        color='primary'
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          setIsOpen((prev) => !prev);
        }}
        variant='circular'
        sx={{
          position: 'fixed',
          bottom: 0,
          right: 0,
          overflow: 'scroll'
        }}
      >
        <Mail />
      </Fab>
      {isOpen && (
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom', horizontal: 'right'
          }}
          sx={{
            // paddingTop: '10rem',
            height: '100%',
            overflow: 'auto'
          }}
          open={isOpen}
          onClick={() => setIsOpen(false)}
        >
          <Box
            display='flex'
            paddingTop='5rem'
            position='fixed'
            bottom='4rem'
            right='0rem'
            flexDirection='column-reverse'
            height='inherit'
            overflow='auto'

          >
            <SnackTest
              notifications={data}
              handleClose={() => setIsOpen(() => false)}
            />
          </Box>

        </Snackbar>
      )}


    </Box>
  );
};


export type SnackTestProps = {
  handleClose: () => void;
  notifications: {
    id: string;
    title: string;
    isRead: boolean;
    content: string;
  }[];
};


const SnackTest = (props: SnackTestProps) => {
  const [fnMarkAsRead] = ds.useSaveNotification();
  return (
    <Stack
      direction='column'
      rowGap='.5rem'
      alignItems='flex-end'
    >
      {props.notifications.filter((node) => !node.isRead).map((node, i) => (
        <SnackbarContent
          key={i}
          sx={{
            maxWidth: '20%',
            background: (theme) => theme.palette.primary.light,
            borderLeft: (theme) => `4px solid ${theme.palette.primary.darker}`,
            color: (theme) => theme.palette.secondary.darker
          }}
          message={(
            <Box>
              <Typography variant='bodyBold'>{node.title}</Typography>
              <Typography variant='body2'>{node.content}</Typography>
            </Box>
          )}
          action={(
            <Button
              color='info'
              onClick={async (e) => {
                e.preventDefault();
                e.stopPropagation();
                await fnMarkAsRead({
                  ids: [node.id]
                });
                props.handleClose();
              }}
              size='small'
            >
              Mark as Read
            </Button>
          )}
        >

        </SnackbarContent>
      ))}
    </Stack>
  );

};
